<ng-container *transloco="let t">
  @if (datasource() !== undefined) {
    <app-grid-layout>
      <div class="h-full w-full">
        <div class="flex items-center justify-between pb-2">
          <div class="flex items-center gap-2">
            <div iInputGroup>
              <IIcon name="search" />
              <input
                iInputGroupInput
                size="sm"
                [placeholder]="t('hourly-table.search_startegy')"
                [(ngModel)]="textFilter"
              />
            </div>
          </div>

          <div class="flex items-center gap-2">
            @if (metric().type === MetricType.RATIO) {
              <button
                iButton
                [variant]="showAbsValues() ? 'secondary' : 'main'"
                [iTooltip]="showAbsValues() ? 'Show relative values' : 'Show absolute values'"
                (click)="showAbsValues.set(!showAbsValues())"
              >
                <IIcon name="percent" />
              </button>
            }
            <app-export-button [iTooltip]="t('common.export_as_csv')" (export)="downloadFile()" />
          </div>
        </div>
        <div class="relative h-full w-full max-w-full overflow-auto">
          <div class="flex flex-row gap-1">
            <div class="sticky left-0 w-[200px] shrink-0 bg-white"></div>
            @for (hour of HOURS; track hour) {
              <div class="shrink-0 text-center text-sm font-medium text-gray-500" [ngClass]="CELL_SIZE_CLASS">
                {{ hour + "H" }}
              </div>
            }
            <div
              class="sticky right-0 shrink-0 bg-white text-right text-sm font-medium text-gray-500"
              [ngClass]="CELL_SIZE_CLASS"
            >
              {{ "Total" }}
            </div>
          </div>

          <div class="flex flex-col gap-1">
            @for (strategy of tableRows(); track strategy) {
              @let strategyId = strategy === "NOT_OPERATED" ? "NOT_OPERATED" : strategy.strategyId;
              @let isDayPartingEditable = strategyId !== "NOT_OPERATED" && !isReadOnly();
              <div class="group/row flex flex-row gap-1">
                <div class="sticky left-0 flex w-[200px] shrink-0 items-center justify-between bg-white">
                  @if (strategy === "NOT_OPERATED") {
                    <span class="text-sm text-gray-500">{{ t("hourly-page.not_operated_campaigns") }}</span>
                  } @else if (strategy.name === "DELETED") {
                    <span class="text-sm text-gray-500">{{ t("hourly-page.deleted_strategy") }}</span>
                  } @else {
                    <app-strategy-link [strategyId]="strategy.strategyId" />
                  }
                </div>
                @for (hour of HOURS; track hour) {
                  @let class = metric() | metricClassBucketPipe: datasource().get(strategyId) : hour;
                  @let stats = datasource().get(strategyId)?.get(hour);
                  @let dayParting = dayPartingByStrategy().get(strategyId);
                  <div
                    class="outline-main-300 flex shrink-0 items-center justify-center rounded-md"
                    [class.cursor-pointer]="isDayPartingEditable"
                    [class.hover:outline-2]="isDayPartingEditable"
                    [class.hover:outline-offset-1]="isDayPartingEditable"
                    [ngClass]="[
                      CELL_SIZE_CLASS,
                      class,
                      dayParting && +hour >= dayParting.start && +hour < dayParting.end
                        ? 'bg-[repeating-linear-gradient(45deg,_#e1e1e1_0,_#e1e1e1_1px,_transparent_0,_transparent_50%)] bg-[size:10px_10px] bg-fixed'
                        : '',
                    ]"
                    [iTooltip]="isDayPartingEditable ? 'Click to activate day parting' : ''"
                    iTooltipPlacement="top-center"
                    (click)="onCellClick(strategyId, +hour)"
                  >
                    @if (stats) {
                      <div class="text-sm">
                        @if (showAbsValues()) {
                          {{
                            metric()
                              | metricFormatPipe: stats : locale() : currency() : undefined : false : true
                              | removePercentPipe
                          }}
                        } @else {
                          {{
                            metric()
                              | metricRelativeValuePipe: stats : totalByStrategy().get(strategyId) : locale() : false
                              | removePercentPipe
                          }}
                        }
                      </div>
                    }
                  </div>
                }
                <div
                  class="sticky right-0 flex shrink-0 items-center justify-end bg-white"
                  [ngClass]="[CELL_SIZE_CLASS]"
                >
                  @let total = totalByStrategy().get(strategyId);
                  @if (total) {
                    <div class="text-sm">
                      {{ metric() | metricFormatPipe: total : locale() : currency() : undefined : false : true }}
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </app-grid-layout>
  }
</ng-container>
